
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { tokenIsExpired } from "../../authUtils";
import { Assessment, Receipt, Inventory, Settings } from "@mui/icons-material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import { Card, CardContent, Button, Grid, Typography, Avatar, Box, IconButton } from "@mui/material";
import { fetchData, fetchData1, updateData, postData, deleteData } from '../../apiService';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ArticleIcon from '@mui/icons-material/Article';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BalanceIcon from '@mui/icons-material/Balance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import CategorySalesChart from './CategorySalesChart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PaidIcon from '@mui/icons-material/Paid';
import PixIcon from '@mui/icons-material/Pix';
import AddCardIcon from '@mui/icons-material/AddCard';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CelebrationIcon from '@mui/icons-material/Celebration';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WaterDamageIcon from '@mui/icons-material/WaterDamage';
import StoreIcon from '@mui/icons-material/Store';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import PersonIcon from '@mui/icons-material/Person';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import HubIcon from '@mui/icons-material/Hub';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DeblurIcon from '@mui/icons-material/Deblur';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function Home() {
    const { isAuthenticated, clubId, branchId, username, userId, logout, token } = useAuth();
    const [showReports, setShowReports] = useState(false);
    const [showMasters, setShowMasters] = useState(false);
    const [showReg, setShowReg] = useState(false);
    const [favorites, setFavorites] = useState([]);
    const { id } = useParams();
    const [formData, setFormData] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [fromdate, setFromDate] = useState("");  // From date state

    useEffect(() => {
        const fetchDataAsync = async () => {
            try {

                if (isAuthenticated && tokenIsExpired(token)) {
                    logout();
                    return;
                }

                if (!userId) {
                    return;
                }

                const profileResponse = await fetchData('ProfileViewApi', `/GetMemberDetails/${userId}`, token);

                if (profileResponse.responseCode === '1111') {
                    const memberDatas = profileResponse.response_data.memberdata;
                    const familyDatas = profileResponse.response_data.familydata;

                    setFormData({
                        ...memberDatas,
                        UpdatedBy: userId,
                    });

                    const permissionResponse = await fetchData1('ProfileViewApi', `/${clubId}/${branchId}/${memberDatas.id}/0`, token);

                    if (permissionResponse?.responsenew) {
                        const feeCheckResponse = await fetchData1('ClubFeesApi', `/${clubId}/${branchId}/0`, token);

                        if (feeCheckResponse?.response === "1") {
                            const confirmResult = window.confirm('Some fees can be generated. Do you want to generate them?');

                            if (confirmResult) {
                                const generateResponse = await fetchData1('ClubFeesApi', `/${clubId}/${branchId}/1`, token);
                                alert('Fees generated successfully!');
                            } else {
                                alert('Fee generation cancelled.');
                            }
                        }
                    } else {
                        console.log('Permission denied');
                    }



                } else {
                    setErrorMessage('Invalid ID. No record found.');
                }
            } catch (error) {
                console.error('Error fetching Member Details:', error);
                setErrorMessage('Failed to fetch member details.');
            }

            const currentDate = new Date().toISOString().split('T')[0];
            setFromDate(currentDate);
        };

        fetchDataAsync();
    }, [userId, isAuthenticated, token, logout]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
    }, [isAuthenticated, token, logout]);

    const features = [
        {
            title: "Master's",
            icon: <DeblurIcon style={{ color: '#333446' }} />,
            action: () => setShowMasters(!showMasters),
        },

        {
            title: "Register / Budget",
            icon: <AdminPanelSettingsIcon style={{ color: '#657C6A' }} />,
            action: () => setShowReg(!showReg),
        },

        { title: "Payment & Receipt", icon: <ReceiptLongIcon style={{ color: '#80B9AD' }} />, link: "/PRIndex" },

        {
            title: "Reports",
            icon: <MenuBookIcon style={{ color: '#27548A' }} />,
            action: () => setShowReports(!showReports),
        },

        {
            title: "Profile",
            icon: <AccountCircleIcon style={{ color: '#333446' }} />, link: "/Home2"
        },
    ];

    const reportsList = [
        { id: 1, name: "Cash Book", icon: <ImportContactsIcon style={{ color: '#C39898' }} />, link: "/CashBook1" },
        { id: 2, name: "Ledger", icon: <SummarizeIcon style={{ color: '#A27B5C' }} />, link: "/Ledger1" },
        { id: 3, name: "Balance Sheet", icon: <SummarizeIcon style={{ color: '#123524' }} />, link: "/BalanceSheet" },
        { id: 4, name: "PR Report", icon: <PermIdentityIcon style={{ color: '#2C3930' }} />, link: "/PRReport1" },
    ];

    const masterList = [
        { id: 1, name: "Business Associates", icon: <PeopleAltIcon style={{ color: '#C39898' }} />, link: "/BusinessAssociatesIndex" },
        { id: 2, name: "Position", icon: <StoreIcon style={{ color: '#A27B5C' }} />, link: "/PositionIndex" },
        { id: 3, name: "Account Parent Groups", icon: <GroupWorkIcon style={{ color: '#123524' }} />, link: "/AccountparentGroups" },
        { id: 4, name: "Fees", icon: <PaidIcon style={{ color: '#2C3930' }} />, link: "/FeesIndex" },
        { id: 5, name: "Generate Fees", icon: <AttachMoneyIcon style={{ color: '#C39898' }} />, link: "/GenerateFees" },
        { id: 6, name: "Asset", icon: <PixIcon style={{ color: '#A27B5C' }} />, link: "/AssetIndex" },
        { id: 7, name: "Account", icon: <AccountBalanceWalletIcon style={{ color: '#123524' }} />, link: "/AccountIndex" },
        { id: 8, name: "Parent Group", icon: <HubIcon style={{ color: '#2C3930' }} />, link: "/ParentGroupIndex" },
        { id: 9, name: "Club Associates Type", icon: <AddCardIcon style={{ color: '#C39898' }} />, link: "/ClubAssociatesTypeIndex" },

    ];

    const bugList = [
        { id: 1, name: "Club Budget", icon: <CurrencyRupeeIcon style={{ color: '#C39898' }} />, link: "/CBIndex" },
        { id: 2, name: "Event Budget", icon: <SummarizeIcon style={{ color: '#A27B5C' }} />, link: "/EBIndex" },
        { id: 3, name: "Member", icon: <SummarizeIcon style={{ color: '#123524' }} />, link: "/MemberIndex" },
        { id: 4, name: "Event", icon: <PermIdentityIcon style={{ color: '#2C3930' }} />, link: "/EventIndex" },
    ];

    const toggleFavorite = async (report) => {
        try {
            const existingItems = await fetchData('PinnedItemsApi', `/${clubId}/${userId}`, token);

            if (
                existingItems.response_data?.some(
                    (item) => item.ReportDescription === report.name
                )
            ) {
                alert('This report is already in your favorites.');
                return;
            }

            const pinned = {
                ReportDescription: report.name,
                ReportId: report.id,
                IsLocked: true,
                ClubId: clubId,
                UserId: userId,
            };

            const response = await postData('PinnedItemsApi', pinned, token);
            fetchtableData(); // Refresh the pinned items
            alert('Favorite added successfully!');
            if (response.status === 200) {
                const updatedFavorites = favorites.includes(report.id)
                    ? favorites.filter((favId) => favId !== report.id)
                    : [...favorites, report.id];
                setFavorites(updatedFavorites);

            } else {
                console.error('Error adding favorite:', response.data?.message || 'Unknown error');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchtableData = async () => {
        fetchData('PinnedItemsApi', `/${clubId}/${userId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Supplier Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleFavoriteRemove = async (id) => {
        try {
            await deleteData('PinnedItemsApi', `${id}`, token); // Perform the delete operation
            fetchtableData(); // Refresh the table data
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    return (
        <div className="container mx-auto p-4">

            <div>
                <Typography variant="h6" className="font-bold justify-end flex items-end" style={{ fontSize: '14px', fontFamily: 'monospace', color: '#1A1A1D', textTransform: 'uppercase' }}>
                    <Diversity1Icon style={{ color: '#547792', fontSize: '14px' }} />
                    <span style={{ fontFamily: 'monospace', fontSize: '12px', marginLeft: '10px', color: '#1A1A1D', textTransform: 'uppercase' }}>
                        Welcome Back, {username || "Guest"}!
                    </span>
                </Typography>
            </div>

            <Grid
                container
                spacing={2}
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-evenly',
                    marginTop: '10px',
                }}
            >
                {features.map((feature, index) => (
                    <Grid
                        item
                        xs={12} sm={4} md={2}
                        key={index}
                        sx={{
                            flex: '1 1 auto',
                            maxWidth: '150px',
                        }}
                    >
                        <Card className="shadow-lg hover:shadow-2xl transition" style={{ borderRadius: '30px' }}>
                            <CardContent className="text-center" style={{ height: '100px', backgroundColor: '#FFFAEC' }}>
                                <div className="text-blue-500 mb-2" style={{ marginTop: '-10px' }}>{feature.icon}</div>
                                <Typography
                                    variant="h6"
                                    className="font-bold"
                                    sx={{ fontSize: '14px', fontFamily: 'monospace', color: '#1A1A1D', textTransform: 'uppercase' }}
                                >
                                    {feature.title}
                                </Typography>
                                {feature.link ? (
                                    <Button
                                        component={Link}
                                        to={feature.link}
                                        className="mt-2"
                                        style={{ backgroundColor: 'none', marginTop: '-10px', color: 'red' }}
                                    >
                                        <span style={{ color: 'red' }}>open</span>
                                        {/* <ArrowCircleRightIcon className="ml-1" style={{ marginTop: '-5px' }} /> */}
                                    </Button>
                                ) : (
                                    <Button
                                        onClick={feature.action}
                                        className="mt-2"
                                    >
                                        <span style={{ color: 'red' }}>View</span>
                                        {/* <ArrowCircleRightIcon className="ml-1" /> */}
                                    </Button>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>



            {showMasters && (
                <>
                    <h6 style={{ marginTop: '20px', fontFamily: 'monospace', textTransform: 'uppercase' }}>Master</h6>
                    <Box
                        className="mt-4 p-4 border rounded shadow-lg"
                        sx={{
                            display: 'grid',
                            gap: 2,
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: '1fr 1fr',
                                md: 'repeat(4, 1fr)',
                                lg: 'repeat(5, 1fr)',
                            },
                            animation: 'fadeIn 1s ease-in-out',
                            border: 'none',
                        }}
                        style={{
                            '@keyframes fadeIn': {
                                from: { opacity: 0, transform: 'translateY(10px)' },
                                to: { opacity: 1, transform: 'translateY(0)' },
                            },
                        }}
                    >
                        {masterList.map((master, index) => (
                            <Card
                                key={index}
                                className="p-4 shadow-lg hover:shadow-2xl transition"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    color: '#1A1A1D',
                                    textTransform: 'uppercase',
                                    height: '90px',
                                    animation: `cardFadeIn 0.5s ease-in-out ${index * 0.2}s`,
                                    backgroundColor: '#FEFAF6',
                                    borderRadius: '30px',
                                }}
                                style={{
                                    '@keyframes cardFadeIn': {
                                        from: { opacity: 0, transform: 'scale(0.9)' },
                                        to: { opacity: 1, transform: 'scale(1)' },
                                    },
                                }}
                            >
                                <CardContent className="text-center" >
                                    <div
                                        className="text-blue-500 mb-2"
                                        style={{ marginTop: '-35px' }}
                                    >
                                        {master.icon}
                                    </div>
                                    <Typography
                                        variant="h6"
                                        className="font-bold"
                                        component={Link}
                                        to={master.link}
                                        sx={{
                                            fontSize: '14px',
                                            fontFamily: 'monospace',
                                            textDecoration: 'none',
                                            color: 'inherit',
                                            '&:hover': {
                                                color: 'inherit',
                                            },
                                        }}
                                    >
                                        {master.name}
                                    </Typography>

                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </>
            )}


            {showReg && (
                <>
                    <h6 style={{ marginTop: '20px', fontFamily: 'monospace', textTransform: 'uppercase' }}>Registration / Budget</h6>
                    <Box
                        className="mt-4 p-4 border rounded shadow-lg"
                        sx={{
                            display: 'grid',
                            gap: 2,
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: '1fr 1fr',
                                md: 'repeat(4, 1fr)',
                                lg: 'repeat(5, 1fr)',
                            },
                            animation: 'fadeIn 1s ease-in-out',
                            border: 'none',
                        }}
                        style={{
                            '@keyframes fadeIn': {
                                from: { opacity: 0, transform: 'translateY(10px)' },
                                to: { opacity: 1, transform: 'translateY(0)' },
                            },
                        }}
                    >
                        {bugList.map((bug, index) => (
                            <Card
                                key={index}
                                className="p-4 shadow-lg hover:shadow-2xl transition"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    color: '#1A1A1D',
                                    textTransform: 'uppercase',
                                    height: '90px',
                                    animation: `cardFadeIn 0.5s ease-in-out ${index * 0.2}s`,
                                    backgroundColor: '#FEFAF6',
                                    borderRadius: '30px',
                                }}
                                style={{
                                    '@keyframes cardFadeIn': {
                                        from: { opacity: 0, transform: 'scale(0.9)' },
                                        to: { opacity: 1, transform: 'scale(1)' },
                                    },
                                }}
                            >
                                <CardContent className="text-center" >
                                    <div
                                        className="text-blue-500 mb-2"
                                        style={{ marginTop: '-35px' }}
                                    >
                                        {bug.icon}
                                    </div>
                                    <Typography
                                        variant="h6"
                                        className="font-bold"
                                        component={Link}
                                        to={bug.link}
                                        sx={{
                                            fontSize: '14px',
                                            fontFamily: 'monospace',
                                            textDecoration: 'none',
                                            color: 'inherit',
                                            '&:hover': {
                                                color: 'inherit',
                                            },
                                        }}
                                    >
                                        {bug.name}
                                    </Typography>

                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </>
            )}

            {showReports && (
                <>
                    <h6 style={{ marginTop: '20px', fontFamily: 'monospace', textTransform: 'uppercase' }}>Reports</h6>
                    <Box
                        className="mt-4 p-4 border rounded shadow-lg"
                        sx={{
                            display: 'grid',
                            gap: 2,
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: '1fr 1fr',
                                md: 'repeat(4, 1fr)',
                                lg: 'repeat(5, 1fr)',
                            },
                            animation: 'fadeIn 1s ease-in-out',

                        }}
                        style={{
                            '@keyframes fadeIn': {
                                from: { opacity: 0, transform: 'translateY(10px)' },
                                to: { opacity: 1, transform: 'translateY(0)' },
                            },
                        }}
                    >
                        {reportsList.map((report, index) => (
                            <Card
                                key={index}
                                className="p-4 shadow-lg hover:shadow-2xl transition"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    color: '#1A1A1D',
                                    textTransform: 'uppercase',
                                    height: '90px',
                                    animation: `cardFadeIn 0.5s ease-in-out ${index * 0.2}s`,

                                    borderRadius: '30px',
                                }}
                                style={{
                                    '@keyframes cardFadeIn': {
                                        from: { opacity: 0, transform: 'scale(0.9)' },
                                        to: { opacity: 1, transform: 'scale(1)' },
                                    },
                                }}
                            >
                                <CardContent className="text-center">
                                    <div
                                        className="text-blue-500 mb-2"
                                        style={{ marginTop: '-35px' }}
                                    >
                                        {report.icon}
                                    </div>
                                    <Typography
                                        variant="h6"
                                        className="font-bold"
                                        component={Link}
                                        to={report.link}
                                        sx={{
                                            fontSize: '14px',
                                            fontFamily: 'monospace',
                                            textDecoration: 'none',
                                            color: 'inherit',
                                            '&:hover': {
                                                color: 'inherit',
                                            },
                                        }}
                                    >
                                        {report.name}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </Box>
                </>
            )}

            {data.length > 0 && (
                <Box className="mt-4 p-4 border rounded shadow-lg">
                    <Typography variant="h6" style={{ fontSize: '14px', marginBottom: '10px', fontFamily: 'monospace', textTransform: 'uppercase', color: 'darkred' }}>Pinned Reports</Typography>
                    <Grid container spacing={2}>
                        {data.map((report, index) => (
                            <Grid item xs={6} sm={5} md={2.9} key={index}>
                                <Card className="p-4 shadow-lg hover:shadow-2xl transition"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        color: '#410445',
                                        textTransform: 'uppercase',
                                        height: '110px',
                                        animation: `cardFadeIn 0.5s ease-in-out ${index * 0.2}s`,

                                    }}
                                    style={{
                                        '@keyframes cardFadeIn': {
                                            from: { opacity: 0, transform: 'scale(0.9)' },
                                            to: { opacity: 1, transform: 'scale(1)' },
                                        },
                                    }}
                                >
                                    <CardContent className="text-center" style={{ backgroundColor: '#E4EFE7' }}>
                                        <div style={{ marginTop: '-35px' }}>{report.icon}</div>
                                        <Typography variant="h6" className="font-bold" sx={{ fontSize: '14px', fontFamily: 'monospace' }}>{report.ReportDescription}</Typography>
                                        <Button
                                            component={Link}
                                            to={
                                                report.ReportDescription === "CashBook"
                                                    ? "/CashBook"
                                                    : report.ReportDescription === "Ledger"
                                                        ? "/Ledger"
                                                        : report.ReportDescription === "Creditor Debitor"
                                                            ? "/CreditorDebitorReport"
                                                            : report.ReportDescription === "Customer Outstanding"
                                                                ? "/CustomerOutstandingReport"
                                                                : report.ReportDescription === "Supllier Outstanding"
                                                                    ? "/SupplierOutstandingReport"
                                                                    : report.ReportDescription === "Purchase Register"
                                                                        ? "/PurchaseRegisterReport"
                                                                        : report.ReportDescription === "Sale HSNC"
                                                                            ? "/SaleHSNCReport"
                                                                            : report.ReportDescription === "SaleRegister"
                                                                                ? "/Sale Register"
                                                                                : report.ReportDescription === "SaleGstReport"
                                                                                    ? "/Sale Gst"
                                                                                    : report.ReportDescription === "Stock"
                                                                                        ? "/Stock"
                                                                                        : report.ReportDescription === "Daily Sale Profit"
                                                                                            ? "/DailySaleProfitReport"
                                                                                            : report.ReportDescription === "Trial Balance"
                                                                                                ? "/TrialBalanceReport"
                                                                                                : report.link
                                            }
                                            variant="outlined"
                                            color="primary"
                                            className="mt-2"
                                        >
                                            Open
                                        </Button>

                                        <IconButton onClick={() => handleFavoriteRemove(report.Id)}>
                                            <FavoriteIcon />
                                        </IconButton>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}

        </div>
    );
}

export default Home;